<template>
  <div>
    <!-- form starts -->
    <vue-element-loading
      :active="isSubmitted"
      text="MYLE"
      :text-style="loadStyle"
      :is-full-screen="true"
      class="h-full background-overlay"
      spinner="bar-fade-scale"
      color="#ffffff"
    />

    <stripe-checkout
      ref="checkoutRef"
      mode="payment"
      :pk="checkout.publishKey"
      :sessionId="checkout.clientReferenceId"
    />
    <nu-modal ref="modal">
      <form>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="text-center">
                <h3 class="w-auto d-inline-block">Donation Form</h3>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <p>
                <b class="font-weight-bold">Donation Title:</b>
                {{
                  TicketsResult[selected]
                    ? TicketsResult[selected].ticketName
                    : ""
                }}
              </p>
              <p v-if="!redeemData">
                <b class="font-weight-bold">Per Person Amount:</b> ${{
                  TicketsResult[selected]
                    ? TicketsResult[selected].price.toFixed(2)
                    : ""
                }}
              </p>
              <p v-if="redeemData">
                <b class="font-weight-bold">Per Person Price:</b> ${{
                  redeemData.price.toFixed(2)
                }}
              </p>
              <p v-if="!redeemData">
                <b class="font-weight-bold">Total Amount: </b> ${{
                  (
                    (TicketsResult[selected]
                      ? TicketsResult[selected].price
                      : 0) * tickcount
                  ).toFixed(2)
                }}
              </p>
              <p v-if="redeemData">
                <b class="font-weight-bold">Total Amount: </b> ${{
                  ((redeemData.price || 0) * tickcount).toFixed(2)
                }}
              </p>
            </div>
            <div class="col-md-6">
              <input
                type="text"
                class="form-control mb-3"
                placeholder="Full Name"
                required
                v-model="fullname"
              />
            </div>
            <div class="col-md-6">
              <input
                type="email"
                class="form-control mb-3"
                placeholder="Email"
                v-model="email"
                required
              />
            </div>
            <div
              class="col-md-6 mb-1"
              v-if="
                false &&
                TicketsResult[selected] &&
                TicketsResult[selected].ticketCode !== 'tk_yfT2rMpbdhrWJNg'
              "
            >
              <label class="mt-3">Number of Donation(s)</label>
              <select class="form-control" v-model="tickcount">
                <option
                  class="form-control"
                  v-bind:key="count + 'b'"
                  v-for="count in tickcountlist"
                  :value="count"
                >
                  {{ count }}
                </option>
              </select>
            </div>

            <div
              class="col-md-6 mb-1"
              v-if="
                ((TicketsResult[selected] || {}).availableSeating || [])
                  .length > 0 &&
                (TicketsResult[selected] || {}).ticketCode ==
                  'tk_bMMncT7WBaGEmz0'
              "
            >
              <label class="mt-3">Available Seating</label>
              <select class="form-control" v-model="availSeating">
                <option
                  class="form-control"
                  v-bind:key="seating.table"
                  v-for="seating in uniq(
                    (TicketsResult[selected] || {}).availableSeating
                  )"
                  :value="seating"
                >
                  {{ seating }}
                </option>
              </select>
            </div>

            <div
              class="col-md-6 mb-1"
              v-if="
                ((TicketsResult[selected] || {}).availableSeating || [])
                  .length > 0 &&
                (TicketsResult[selected] || {}).ticketCode ==
                  'tk_ZNDRjDCAnOGEjAn'
              "
            >
              <label class="mt-3">Available Seating</label>
              <select class="form-control" v-model="availSeating">
                <option
                  class="form-control"
                  v-bind:key="seating.table"
                  v-for="seating in uniq1(
                    (TicketsResult[selected] || {}).availableSeating
                  )"
                  :value="seating"
                >
                  {{ seating }}
                </option>
              </select>
            </div>

            <div
              class="col-md-6 mt-3"
              v-if="TicketsResult[selected] && TicketsResult[selected].discount"
            >
              <label class="">Do you have a promo code?</label>

              <input
                type="text"
                v-model="redeempromo"
                class="form-control"
                placeholder="Promo code"
              />
            </div>

            <div
              class="col-md-6"
              v-if="TicketsResult[selected] && TicketsResult[selected].discount"
            ></div>

            <div class="row mx-0">
              <div class="col-md-6 mt-2">
                <label class="">Phone Number</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Phone Number"
                  v-model="pnumber"
                />
              </div>

              <div class="col-md-6 mt-2">
                <label class="">Mailing Address</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Mailing Address"
                  v-model="maddress"
                />
              </div>

              <div class="col-md-6">
                <label class="">City</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="City"
                  v-model="ccity"
                />
              </div>

              <div class="col-md-6">
                <label class="">State</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="State"
                  v-model="cstate"
                />
              </div>

              <div class="col-md-6">
                <label class="">Zipcode</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Zipcode"
                  v-model="czipcode"
                />
              </div>

              <div class="col-md-6">
                <label class="">Company</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Company"
                  v-model="company"
                />
              </div>
            </div>
            <div
              class="col-md-6 text-center"
              id="redeem"
              v-if="TicketsResult[selected] && TicketsResult[selected].discount"
            >
              <button
                type="button"
                @click="redeem()"
                :disabled="!redeempromo.trim().length"
                class="btn solid-btn btn-sm my-auto"
                id="reserve"
                style="
                  pointer-events: all;
                  cursor: pointer;
                  padding: 7px;
                  margin-top: 11px !important;
                "
              >
                Redeem Code
              </button>
            </div>

            <div
              class="col-md-12 mt-2"
              v-if="
                TicketsResult[selected] &&
                TicketsResult[selected].ticketCode == 'tk_yfT2rMpbdhrWJNg'
              "
            >
              <doublelist
                @listtopush="listtopush"
                v-if="
                  TicketsResult[selected] &&
                  TicketsResult[selected].availableSeating.length > 0
                "
                :list="(TicketsResult[selected] || {}).availableSeating"
                :limit="(TicketsResult[selected] || {}).allowedPerRequest || 0"
              />
            </div>

            <div class="col-md-12 mt-2">
              <input type="checkbox" v-model="followup" />
              Would like a follow-up to make donation a recurring payment
            </div>

            <div class="col-md-12 mt-2" v-if="isDonation">
              <input type="checkbox" v-model="isDonationPay" />
              Donate Anonymously
            </div>

            <div class="col-md-12 mt-4">
              <input type="checkbox" v-model="reserveFormAccept" />
              I understand that all sales are final. No refunds. I have read and
              agree with the MYLE
              <a
                href="https://myle.com/terms"
                target="_blank"
                rel="noopener noreferrer"
              >
                terms and conditions.</a
              >
            </div>

            <div class="col-md-12 text-center mt-4">
              <button
                type="submit"
                @click="paynow()"
                :disabled="
                  !maddress.trim().length ||
                  !cstate.trim().length ||
                  !ccity.trim().length ||
                  !czipcode.trim().length ||
                  !invalidPhoneNum ||
                  (TicketsResult[selected] &&
                  groupData.includes(TicketsResult[selected].ticketCode)
                    ? !required_power_needs.trim().length
                    : false) ||
                  !fullname.trim().length ||
                  !invalidemail ||
                  isSubmitted ||
                  !tickcountlist.length ||
                  !reserveFormAccept ||
                  (TicketsResult[selected] &&
                  TicketsResult[selected].ticketCode == 'tk_yfT2rMpbdhrWJNg'
                    ? selectionList.length < 1
                    : false)
                "
                class="btn solid-btn m-auto mr-2"
                id="reserve"
                style="pointer-events: all; cursor: pointer"
              >
                Donate now
              </button>
            </div>
          </div>
        </div>
      </form>
    </nu-modal>
    <!-- form ends -->

    <!-- zelle model -->
    <nu-modal ref="zellemodal">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center">
            <img
              style="width: 80%; max-width: 80%"
              src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/zelle.jpeg"
            />
          </div>
        </div>
      </div>
    </nu-modal>
    <!-- zelle model -->

    <div class="container-fluid p-0" style="overflow-x: hidden">
      <!-- Navbar section starts -->
      <div class="row">
        <div class="col-md-12">
          <nav-bar />
        </div>
      </div>
      <!-- Navbar section ends -->

      <!-- banner section starts -->
      <div class="row text-center">
        <div class="col-md-12" id="banner">
          <img
            class="align-middle"
            src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/header_ColumbusUrbanLeagueEmpowermentDay.png"
            style="
              width: 100%;
              max-width: 100%;
              height: auto;
              margin-top: 4.6rem;
            "
          />
        </div>
      </div>
      <!-- banner section ends -->
      <div class="row w-100 m-0 promo-section MYLE-lite-green">
        <div class="col-lg-12 col-md-12">
          <div class="mt-4">
            <div class="section-heading mb-4">
              <h1
                class="text-center"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 700;
                  color: white;
                "
              >
                Columbus Urban League Empowerment Day
              </h1>

              <h1
                class="text-center"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                  color: white;
                "
              >
                Thursday, November 16, 2023, <br />
                11:00am - 01:00pm
              </h1>

              <h1
                class="text-center"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                <a
                  href="https://maps.app.goo.gl/CZNweqDSzqDUafEd8"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="color: white"
                >
                  Hilton Columbus Downtown
                </a>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <!-- Description section starts -->
      <div
        class="row align-items-center justify-content-between test"
        style="margin: auto; margin-top: 20px"
      >
        <div class="col-md-12">
          <div class="col-md-12">
            <div class="download-content">
              <p
                class=""
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                Empowerment Day 2023 honors local businesses and community
                leaders championing change and paving the way for equitable
                economic and social impact. Over the past year, your Columbus
                Urban League has actively adopted and works to emphasize the
                research-based principles of asset-framing. We aim to empower
                individuals to realize their potential and dreams, ultimately
                fostering a fully inclusive economy that benefits everyone in
                Central Ohio.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Description section ends -->

      <!-- <div
          id="d2"
          style="max-width: 900px; margin: auto; height: auto; margin-top: 50px"
        ></div> -->

      <!-- <div
          class="row align-items-center justify-content-center test"
          style="margin: auto; margin-top: 20px"
        >
          <div
            class="col-md-3 align-items-center justify-content-center"
            style="display: flex"
          >
            <table>
              <tbody>
                <tr>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        background: #0ea293;
                        color: #0ea293;
                        width: 20px;
                        height: 20px;
                        margin-right: 3px;
                      "
                    ></div>
                  </td>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 500;
                        font-size: 12px;
                      "
                    >
                      Scholarship Gala-Individual
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-md-3 align-items-center justify-content-center"
            style="display: flex"
          >
            <table>
              <tbody>
                <tr>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        background: #a19140;
                        color: black;
                        width: 20px;
                        height: 20px;
                        margin-right: 3px;
                      "
                    ></div>
                  </td>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 500;
                        font-size: 12px;
                      "
                    >
                      Reserved Seating (Full Table - Seats 10)
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-md-3 align-items-center justify-content-center"
            style="display: flex"
          >
            <table>
              <tbody>
                <tr>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        background: #c07f00;
                        color: #c07f00;
                        width: 20px;
                        height: 20px;
                        margin-right: 3px;
                      "
                    ></div>
                  </td>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 500;
                        font-size: 12px;
                      "
                    >
                      Reserved Seating (Half Table - Seats 5)
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-md-3 align-items-center justify-content-center"
            style="display: flex"
          >
            <table>
              <tbody>
                <tr>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        background: lightgrey;
                        color: lightgrey;
                        width: 20px;
                        height: 20px;
                        margin-right: 3px;
                      "
                    ></div>
                  </td>
                  <td style="vertical-align: middle">
                    <div
                      style="
                        font-family: 'Quicksand', sans-serif;
                        font-weight: 500;
                        font-size: 12px;
                      "
                    >
                      Reserved
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->

      <div class="row">
        <vueThermometer
          :value="thermoResult"
          :min="5"
          scale="k"
          :max="50"
          :options="options"
          customClass="marginclass"
        />
      </div>

      <div class="row">
        <div class="col-md-12" style="text-align: center">
          <br />
          <h3
            class="w-auto d-inline-block mb-2"
            v-if="salesRecords.length > 0"
            style="
              font-family: 'Quicksand', sans-serif;
              font-weight: 700;
              font-size: 30px;
              margin: auto;
              text-align: center;
              width: 100% !important;
            "
          >
            Latest Donations
          </h3>
          <!-- <div
         class="texts"
         v-bind:key="objk"
         v-for="(obj, objk) in salesRecords">
          {{ obj.user.fullName + " -" }} <span class="amount">{{ " $" + obj.totalPaid }}</span>
        </div> -->

          <marquee
            width="60%"
            direction="left"
            behavior="scroll"
            scrollamount="10"
          >
            <span
              v-bind:key="objk"
              v-for="(obj, objk) in salesRecords"
              class="fullName"
            >
              {{ obj.user.fullName + " -" }}
              <span class="amount">{{ " $" + obj.totalPaid + "   " }} </span>
            </span>
          </marquee>
        </div>
      </div>

      <!-- Tickets Section starts -->
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="py-5">
            <div class="text-center">
              <h3
                class="w-auto d-inline-block mb-2"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 700;
                  font-size: 30px;
                "
              >
                DONATION OPTIONS
              </h3>
              <br />
              <h3
                class="w-auto d-inline-block mb-2"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                To Donate by Credit Card, select Donation Amount Below.
              </h3>

              <br />
              <h3
                class="w-auto d-inline-block mb-2"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                OR
              </h3>
              <br />
              <h3
                class="w-auto d-inline-block mb-2"
                style="
                  font-family: 'Quicksand', sans-serif;
                  font-weight: 500;
                  font-size: 18px;
                "
              >
                To Donate by Cash App, Paypal, Zelle or Venmo,

                <a href="#manual-donations"> click here. </a>
              </h3>
            </div>
            <div class="d-flex flex-row flex-wrap justify-content-center">
              <div
                class="card mx-4 mt-4"
                style="
                  max-width: 400px !important;
                  border-radius: 10px;
                  overflow: hidden;
                "
                v-bind:key="objk"
                v-for="(obj, objk) in individualTick(TicketsResult)"
              >
                <div
                  class="card-header MYLE-green white"
                  style="color: white; width: 310px !important"
                >
                  {{ obj.ticketName }}
                </div>
                <div
                  class="card-body"
                  style="display: flex; flex-direction: column"
                >
                  <p
                    v-bind:key="w"
                    v-for="(msgs, w) in (tkList[obj.ticketCode] || []).messages"
                  >
                    - {{ msgs }}
                  </p>
                  <div class="text-center" style="margin-top: auto">
                    <p>
                      <b class="font-weight-bold">Total Amount: </b>${{
                        obj.price.toFixed(2)
                      }}
                    </p>
                    <p
                      v-bind:key="linek"
                      v-for="(line, linek) in obj.description"
                    >
                      {{ line }}
                    </p>
                    <button
                      :disabled="
                        !obj.availableTickets ||
                        obj.status == 'EXPIRED' ||
                        obj.status == 'COMING_SOON'
                      "
                      v-bind:class="{
                        'bg-disable':
                          obj.status == 'EXPIRED' ||
                          !obj.availableTickets ||
                          obj.status == 'COMING_SOON',
                        cgreen: obj.ticketCode == 'tk_yfT2rMpbdhrWJNg',
                        cred: obj.ticketCode == 'tk_ZNDRjDCAnOGEjAn',
                        cgold: obj.ticketCode == 'tk_bMMncT7WBaGEmz0',
                      }"
                      class="btn solid-btn"
                      id="reserve"
                      @click="openmodel(obj)"
                      style="
                        pointer-events: all;
                        cursor: pointer;
                        font-size: 18px;
                      "
                    >
                      {{
                        obj.status == "EXPIRED" || !obj.availableTickets
                          ? "Sold Out"
                          : obj.status == "COMING_SOON"
                          ? "Coming Soon"
                          : "Donate Now"
                      }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form SECTION -->
      <section id="manual-donations">
        <form>
          <div class="container mt-5">
            <!-- heading -->
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <h3
                    class="w-auto d-inline-block"
                    style="
                      font-family: 'Quicksand', sans-serif;
                      font-weight: 700;
                      font-size: 32px;
                    "
                  >
                    3rd Party Donation Options
                  </h3>
                </div>
              </div>
            </div>
            <!-- heading -->

            <h6
              class="text-center"
              style="
                font-family: 'Quicksand', sans-serif;
                font-weight: 500;
                font-size: 22px;
              "
            >
              If using Cash App, Paypal, Zelle or Venmo, please follow these
              steps
            </h6>
            <br />
            <h6
              style="
                font-family: 'Quicksand', sans-serif;
                font-weight: 700;
                font-size: 22px;
              "
            >
              STEP 1:
            </h6>
            <h6
              style="
                font-family: 'Quicksand', sans-serif;
                font-weight: 500;
                font-size: 18px;
              "
            >
              Complete and submit donation form below
            </h6>

            <!-- form -->
            <div class="row my-3">
              <div class="col-md-4">
                <label>Name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="ticketForm.name"
                  required
                />
              </div>
              <div class="col-md-4">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email"
                  v-model="ticketForm.email"
                  required
                />
              </div>
              <div class="col-md-4">
                <label>Phone No.</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Phone"
                  v-model="ticketForm.phone"
                  required
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <label class="">Mailing Address</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Mailing Address"
                  v-model="conaddress"
                />
              </div>

              <div class="col-md-4">
                <label class="">City</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="City"
                  v-model="concity"
                />
              </div>

              <div class="col-md-4">
                <label class="">State</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="State"
                  v-model="constate"
                />
              </div>

              <div class="col-md-4">
                <label class="">Zipcode</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Zipcode"
                  v-model="conzipcode"
                />
              </div>

              <div class="col-md-4">
                <label class="">Company</label>
                <input
                  type="text"
                  class="form-control mb-3"
                  placeholder="Company"
                  v-model="concompany"
                />
              </div>

              <div class="col-md-4">
                <label>Donation Option</label>
                <select
                  class="form-control"
                  v-model="ticketForm.ticketName"
                  @change="onChangeTicket($event)"
                >
                  <option
                    class="form-control"
                    v-bind:key="count + 'a'"
                    v-for="count in eventTicketResult.filter(
                      (e) =>
                        e.status != 'EXPIRED' &&
                        e.availableTickets &&
                        e.status != 'COMING_SOON' &&
                        e.ticketType != 'FREE'
                    )"
                    :value="count.ticketName"
                  >
                    {{ count.ticketName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="row my-3">
              <div class="col-md-4" v-if="false">
                <label>No. of donation(s)</label>
                <select class="form-control" v-model="ticketForm.ticketCount">
                  <option
                    class="form-control"
                    v-bind:key="count + 'b'"
                    v-for="count in countsListShow"
                    :value="count"
                  >
                    {{ count }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-2">
                <input type="checkbox" v-model="confollowup" />
                Would like a follow-up to make donation a recurring payment
              </div>

              <div class="col-md-12" v-if="isDonation">
                <input type="checkbox" v-model="conisDonationPay" />
                Donate Anonymously
              </div>
            </div>

            <!-- <div class="row my-3">
              <div class="col-md-12">
                <label class="mr-3">Receipt</label>
                <input
                  name="image"
                  type="file"
                  id="fileName"
                  accept=".jpg,.jpeg,.png"
                  @change="validateFileType($event)"
                />
              </div>
            </div> -->

            <!-- <div class="row my-3">
              <div class="col-md-12 d-flex justify-content-left">
                <label class="mr-3">Pay Method</label>
                <div class="payment-method mx-2">
                  <input
                    type="radio"
                    value="Paypal"
                    v-model="ticketForm.method"
                    id="paypal"
                  />
                  <label class="ml-1" for="paypal">Paypal</label>
                </div>
                <div class="payment-method mx-2">
                  <input
                    id="zelle"
                    type="radio"
                    value="Zelle"
                    v-model="ticketForm.method"
                  />
                  <label class="ml-1" for="zelle">Zelle</label>
                </div>
                <div class="payment-method mx-2">
                  <input
                    id="venmo"
                    type="radio"
                    value="Venmo"
                    v-model="ticketForm.method"
                  />
                  <label class="ml-1" for="venmo">Venmo</label>
                </div>
                <div class="payment-method">
                  <input
                    type="radio"
                    value="Cash App"
                    v-model="ticketForm.method"
                    id="cashup"
                  />
                  <label class="ml-1" for="cashup">Cash App</label>
                </div>
              </div>
            </div> -->

            <div class="row mb-2">
              <div class="col-md-12 mb-4">
                <input type="checkbox" v-model="ticketForm.accept" />
                I understand that all sales are final. No refunds. I have read
                and agree with the MYLE
                <a
                  href="https://myle.com/terms"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  terms and conditions.</a
                >
              </div>
            </div>

            <div class="row mb-2">
              <div class="col-md-12 text-center">
                <button
                  type="button"
                  @click="payfornow()"
                  :disabled="
                    !ticketForm.name.trim().length ||
                    !ticketForm.ticketName.trim().length ||
                    !ticketForm.ticketCount === 0 ||
                    !invalidTicketEmail ||
                    !invalidTicketPhone ||
                    !ticketForm.accept ||
                    // !ticketForm.file ||
                    isSubmitted ||
                    !constate.trim().length ||
                    !concity.trim().length ||
                    !conzipcode.trim().length
                  "
                  class="btn solid-btn m-auto"
                  style="pointer-events: all; cursor: pointer"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </form>
      </section>
      <!-- Form SECTION -->

      <!-- MANUAL PURCHASE -->
      <section id="download" class="white-bg ptb-50">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="container">
                <h6
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 700;
                    font-size: 22px;
                  "
                >
                  STEP 2:
                </h6>
                <h6
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 500;
                    font-size: 18px;
                  "
                >
                  Select donation option & make donation
                </h6>
              </div>

              <div class="mt-4 text-center">
                <div class="row equal">
                  <div
                    class="col-md-3 col-lg-3"
                    style="
                      background-image: linear-gradient(
                        136deg,
                        #145143 0%,
                        #0c2f1f 100%
                      );
                    "
                  >
                    <a
                      href="https://cash.app/$MYLEMARKERS"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div
                        class="single-promo single-promo-hover single-promo-1 rounded text-center navColor p-3 h-30"
                      >
                        <div class="circle-icon mb-3">
                          <span class="">
                            <img
                              class="align-middle"
                              src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/ic_cash_icon.png"
                              style="width: 15%; max-width: 15%; height: auto"
                            />
                          </span>
                        </div>
                        <h3 class="text-white bold">Cash App</h3>
                        <p class="text-white lead">MYLEMARKERS</p>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <a
                      href="https://www.paypal.me/myletickets?"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div
                        class="single-promo single-promo-hover single-promo-1 rounded text-center navColor p-3 h-30"
                      >
                        <div class="circle-icon mb-3">
                          <span class=""
                            ><img
                              class="align-middle"
                              src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/ic_paypal_icon.png"
                              style="width: 15%; max-width: 15%; height: auto"
                          /></span>
                        </div>
                        <h3 class="text-white">Paypal</h3>
                        <p class="text-white lead">tickets@myle.com</p>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div
                      class="single-promo single-promo-hover single-promo-1 rounded text-center navColor p-3 h-30"
                    >
                      <div class="circle-icon mb-3">
                        <span class=""
                          ><img
                            class="align-middle"
                            src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/ic_zelle_icon.png"
                            style="width: 15%; max-width: 15%; height: auto"
                        /></span>
                      </div>
                      <h3 class="text-white">Zelle</h3>
                      <p class="text-white lead">tickets@myle.com</p>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <a
                      href="https://venmo.com/code?user_id=3449043321620189533"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div
                        class="single-promo single-promo-hover single-promo-1 rounded text-center navColor p-3 h-30"
                      >
                        <div class="circle-icon mb-3">
                          <span class=""
                            ><img
                              class="align-middle"
                              src="https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/ic_venmo_icon.png"
                              style="width: 15%; max-width: 15%; height: auto"
                          /></span>
                        </div>
                        <h3 class="text-white">Venmo</h3>
                        <p class="text-white lead">MYLEMARKERS</p>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br /><br />
          <div class="container">
            <!-- <h6
              style="
                font-family: 'Quicksand', sans-serif;
                font-weight: 700;
                font-size: 22px;
              "
            >
              STEP 3:
            </h6> -->
            <h6
              style="
                font-family: 'Quicksand', sans-serif;
                font-weight: 500;
                font-size: 18px;
              "
            >
              Your investment in the Columbus Urban League means the world to
              us. Together, we’re making significant strides towards a more
              empowered and inclusive community. – Thank You
            </h6>
          </div>

          <!-- <h6 class="mb-3 mt-5 font-bold">
            If using Cash App, Paypal, Zelle or Venmo, please follow these
            steps:
          </h6>

          <span class="font-weight-bold selfBullet">•</span> Complete the
          Donation Confirmation Fields below<br />
          <span class="font-weight-bold selfBullet">•</span> Select Donation
          Payment Option<br />

          <span class="font-weight-bold selfBullet">•</span> Complete your
          Donation<br />
          <span class="font-weight-bold selfBullet">•</span> Our team will
          process your transaction and you will receive an email confirmation of
          your donation

          <h6 class="mb-3 mt-3 font-italic">
            Note: Donations for Cash App, Paypal, Zelle and Venmo transactions
            are processed by our team between 9am and 7pm EST daily. You may
            submit at any time.
          </h6> -->
        </div>
      </section>

      <!-- <div
          class="row align-items-center justify-content-between test"
          style="margin: auto"
        >
          <div class="col-md-12">
            <div class="col-md-12">
              <div class="download-content">
                <p
                  class="mb-0"
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 700;
                    font-size: 22px;
                  "
                >
                  Hotel Accommodations
                </p>
                <p
                  class=""
                  style="
                    font-family: 'Quicksand', sans-serif;
                    font-weight: 500;
                    font-size: 18px;
                  "
                >
                  InterContinental Buckhead Atlanta<br />
                  3315 Peachtree Rd NE<br />
                  Atlanta, GA 30326<br />
                  Click
                  <a
                    href="https://book.passkey.com/go/100BlackMenofDekalbGala"
                    target="_blank" rel="noopener noreferrer"
                  >
                    here</a
                  >

                  to reserve your room
                </p>
              </div>
            </div>
          </div>
        </div> -->
    </div>
    <div class="row w-100 m-0 promo-section MYLE-lite-green">
      <div class="col-lg-12 col-md-12">
        <div class="mt-5">
          <div class="section-heading mb-5">
            <h2 class="text-center">Download today and try it for yourself</h2>
            <div
              class="download-btn mt-4 text-center animate__animated animate__fadeIn"
            >
              <a
                href=" https://apps.apple.com/us/app/myle-create-discover-events-curated-for-you/id1162354481"
                class="btn google-play-btn mr-3"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-apple"></span> App Store</a
              >
              <a
                href="https://play.google.com/store/apps/details?id=xyz.getmyle.myle&hl=en&gl=US"
                class="btn google-play-btn mr-3"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-android"></span> Google Play</a
              >
              <a
                href="https://web.myle.com"
                class="btn google-play-btn"
                target="_blank"
                rel="noopener noreferrer"
                ><span class="ti-world"></span> MYLE Web</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <site-footer :show-subscribe="true" />
  </div>
</template>

<script>
// Component Imports
import NavBar from "../../views/commons/NavBar";
import SiteFooter from "../../views/index-five/SiteFooter";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import axios from "axios";
import VueElementLoading from "vue-element-loading";
import vueThermometer from "../../components/VueThermometer.vue";

// tslint-disable no-mixed-spaces-and-tabs
// defining component state
export default {
  name: "newyear",
  data() {
    return {
      conisDonationPay: false,
      confollowup: false,
      concity: "",
      constate: "",
      conzipcode: "",
      concompany: "",
      conaddress: "",
      pnumber: "",
      maddress: "",
      cstate: "",
      ccity: "",
      czipcode: "",
      company: "",
      followup: false,
      isDonation: false,
      isDonationPay: false,
      intID: null,
      salesRecords: [],
      thermoResult: 5,
      options: {
        text: {
          color: "black",
          fontSize: 14,
          textAdjustmentY: 2,
          fontFamily: "Arial",
          textEnabled: true,
        },
        thermo: {
          color: "#145143",
          backgroundColor: "#ffffff",
          frameColor: "black",
          ticks: 10,
          ticksEnabled: true,
          tickColor: "black",
          tickWidth: "1",
        },
        layout: {
          height: 600,
          width: 140,
        },
      },
      selectionList: [],
      dict: {},
      dictlist: {},
      required_power_needs: "No",
      selectedSizes: "Extra Small - XS",
      availSeating: "",
      sizes: [
        "Extra Small - XS",
        "Small - S",
        "Medium - M",
        "Large - L",
        "Extra Large - XL",
        "2 Extra Large - 2XL",
        "3 Extra Large - 3XL",
        "4 Extra Large - 4XL",
        "5 Extra Large - 5XL",
      ],
      individualsData: [
        "tk_CoHMzgGR158saAH",
        "tk_Z8a9fe56BHx9bHr",
        "tk_tlZEJ3dMf2U4WsJ",
        "tk_uSBo0TmAenxf2CP",
        "tk_M2iH8xEoWy9DGWO",
        "tk_tAf85haTa6yuouR",
        "tk_VVhdyaMxvqd4z0K",
        "tk_rTolQ7vpgNhGYWt",
        "tk_EtX0chUOgRB9FY5",
        "tk_S3V709sEL88Mcx4",
        "tk_d0GTCEWbGLuAua7",
      ],
      groupData: [],
      redeempromo: "",
      redeemPriceId: "",
      redeemData: null,
      reserveFormAccept: false,
      tkList: {
        tk_CoHMzgGR158saAH: {
          messages: [],
          // messages: ["Donation Amount: $15"],
        },

        tk_Z8a9fe56BHx9bHr: {
          messages: [],
          // messages: ["Donation Amount: $25"],
        },

        tk_tlZEJ3dMf2U4WsJ: {
          messages: [],
          // messages: ["Donation Amount: $50"],
        },

        tk_uSBo0TmAenxf2CP: {
          messages: [],
          // messages: ["Donation Amount: $75"],
        },

        tk_M2iH8xEoWy9DGWO: {
          messages: [],
          // messages: ["Donation Amount: $100"],
        },

        tk_tAf85haTa6yuouR: {
          messages: [],
          // messages: ["Donation Amount: $200"],
        },

        tk_VVhdyaMxvqd4z0K: {
          messages: [],
          // messages: ["Donation Amount: $350"],
        },

        tk_rTolQ7vpgNhGYWt: {
          messages: [],
          // messages: ["Donation Amount: $500"],
        },

        tk_EtX0chUOgRB9FY5: {
          messages: [],
          // messages: ["Donation Amount: $1000"],
        },

        tk_S3V709sEL88Mcx4: {
          messages: [],
          // messages: ["Donation Amount: $2500"],
        },

        tk_d0GTCEWbGLuAua7: {
          messages: [],
          // messages: ["Donation Amount: $5000"],
        },
      },

      priceIds: {
        tk_CoHMzgGR158saAH: "price_1OC1pCD0vTZ4QB9c1PfbOepx",
        tk_Z8a9fe56BHx9bHr: "price_1O5GnOD0vTZ4QB9cbW0nTHg9",
        tk_tlZEJ3dMf2U4WsJ: "price_1O5GnOD0vTZ4QB9c8w8gvtkI",
        tk_uSBo0TmAenxf2CP: "price_1O5GnPD0vTZ4QB9cJqoWwP3T",
        tk_M2iH8xEoWy9DGWO: "price_1O5GnPD0vTZ4QB9cEenRkBZH",
        tk_tAf85haTa6yuouR: "price_1O5GnQD0vTZ4QB9crmlRRSL4",
        tk_VVhdyaMxvqd4z0K: "price_1O5GnQD0vTZ4QB9ceKuB6Tq5",
        tk_rTolQ7vpgNhGYWt: "price_1O5GnRD0vTZ4QB9cupl23NLE",
        tk_EtX0chUOgRB9FY5: "price_1O5GnRD0vTZ4QB9cvfAc4K4q",
        tk_S3V709sEL88Mcx4: "price_1O5GnRD0vTZ4QB9c8gnDIQr1",
        tk_d0GTCEWbGLuAua7: "price_1OC1pCD0vTZ4QB9ckKOvyQol",
      },

      countsListShow: [],
      eventTicketResult: [],
      selectedAccor: null,
      ticketForm: {
        name: "",
        email: "",
        phone: "",
        ticketCount: 1,
        ticketName: "",
        ticketId: "",
        method: "",
        accept: "",
        file: null,
      },
      loadStyle: {
        color: "#ffffff",
        "font-weight": "bold",
        "letter-spacing": "1rem",
        "font-size": "18px",
      },
      selected: 0,
      fullname: "",
      email: "",
      tickcount: 1,
      isSubmitted: false,
      tickcountlist: [],
      show: false,
      checkout: {
        clientReferenceId: null,
        publishKey:
          "pk_live_51JEQYTD0vTZ4QB9cnmoJMhJQrCybltMAeG2uN3utIarQ342JyZSyyWFXgEdriazLZRFAR1Crne2E1d9PNQFVGxbw00RTp4QVjn",
      },
      TicketsResult: [],
      vfOptions: {
        autoplay: true,
      },
      vfTransitions: [
        "slide",
        "blinds2d",
        "explode",
        "fade",
        "round2",
        "swipe",
        "warp",
        "zip",
      ],
      vfImages: [
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/logo.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/logo.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/mylesite/logo.jpeg",
      ],
      vfEventImgs: [
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_1.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_2.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_3.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_4.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_5.jpeg",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_6.png",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_7.png",
        "https://storage.googleapis.com/wnk1yeeawadm9lfc8qu5ctszt99ghpd1rqh1p7w71bhqiaqfl0tasz1y525o/stadiumImages/Stadium_8.png",
      ],
    };
  },
  components: {
    NavBar,
    SiteFooter,
    VueElementLoading,
    StripeCheckout,
    vueThermometer,
  },
  methods: {
    listtopush(rr) {
      this.selectionList = [...rr];
    },
    uniq(list) {
      if (list && list.length > 0) {
        const bykeyMap = {};
        list.forEach((v) => {
          bykeyMap[v.table] = true;
        });

        return Object.keys(bykeyMap);
      }

      return [];
    },
    uniq1(list) {
      if (list && list.length > 0) {
        const bykeyMap = [];
        list.forEach((v) => {
          if (
            v.seat.split("Seat ")[1] == "1" ||
            v.seat.split("Seat ")[1] == "6"
          ) {
            bykeyMap.push(
              v.table +
                " " +
                "Seat " +
                (v.seat.split("Seat ")[1] == "1" ? "1 to 5" : "6 to 10")
            );
          }
        });

        return bykeyMap;
      }

      return [];
    },
    datad2(listdata) {
      const seat = {
        1: 1200,
        2: 600,
        3: 400,
        4: 300,
        5: 240,
        6: 200,
        7: 171.4285714,
        8: 150,
        9: 133.33333,
        10: 120,
        11: 109.1,
      };

      const zx = [];
      const zobj = {
        0: {
          texts: [1, 2, 3, 4, 5],
          x: 70,
          y: 100,
          count: 5,
        },
        1: {
          texts: [11, 10, 9, 8, 7, 6],
          x: 140,
          y: 70,
          count: 6,
        },
        2: {
          texts: [12, 13, 14, 15, 16, 17],
          x: 210,
          y: 100,
          count: 6,
        },
        3: {
          texts: [22, 21, 20, 19, 18],
          x: 280,
          y: 120,
          count: 5,
        },
        4: {
          texts: [23, 24, 25, 26, 27],
          x: 350,
          y: 150,
          count: 5,
        },
        5: {
          texts: [30, 29, 28],
          x: 420,
          y: 280,
          count: 3,
        },
        6: {
          texts: [31, 32, 33],
          x: 490,
          y: 280,
          count: 3,
        },
        7: {
          texts: [38, 37, 36, 35, 34],
          x: 560,
          y: 150,
          count: 5,
        },
        8: {
          texts: [39, 40, 41, 42, 43],
          x: 630,
          y: 120,
          count: 5,
        },
        9: {
          texts: [49, 48, 47, 46, 45, 44],
          x: 700,
          y: 100,
          count: 6,
        },
        10: {
          texts: [50, 51, 52, 53, 54, 55],
          x: 770,
          y: 70,
          count: 6,
        },
        11: {
          texts: [61, 60, 59, 58, 57, 56],
          x: 840,
          y: 100,
          count: 6,
        },
      };
      for (let j = 0; j < 12; j++) {
        for (let k = 0; k < zobj[j].count; k++) {
          zx.push({
            x: zobj[j].x,
            y: zobj[j].y + k * 80,
            val: seat[10],
            distance: 10,
            ydistance: 10,
            text: zobj[j].texts[k],
          });
        }
      }

      let recs = [];
      this.dict = {};
      this.dictlist = {};

      listdata.forEach((r) => {
        r.availableSeating.forEach((r1) => {
          if (r.ticketCode == "tk_yfT2rMpbdhrWJNg") {
            this.dictlist[r1.table.split("Table ")[1]] = "#0EA293";
          }

          if (r.ticketCode == "tk_bMMncT7WBaGEmz0") {
            this.dictlist[r1.table.split("Table ")[1]] = "#a19140";
          }

          if (r.ticketCode == "tk_ZNDRjDCAnOGEjAn") {
            this.dictlist[r1.table.split("Table ")[1]] = "#C07F00";
          }
        });

        recs = [...recs, ...r.availableSeating];
      });

      recs.forEach((r) => {
        const tableRecord = r.table.split("Table ")[1];
        const seatRecord = r.seat.split("Seat ")[1];

        if (!this.dict[tableRecord]) {
          this.dict[tableRecord] = [];
        }

        this.dict[tableRecord].push(Number(seatRecord) - 1);
      });

      return [...zx];
    },
    drawseatsd2(listdata) {
      const vm = this;
      const svg = window.d3
        .select("div#d2")
        .append("svg")
        .attr("width", "900px")
        .attr("height", "555px");
      const innerCircleRadius = 15;
      const outerCircleRadius = 15;
      const outerCircleRadius1 = 15;

      this.datad2(listdata).forEach((v) => {
        const originX = v.x + v.distance;
        const originY = v.y + v.ydistance;

        svg.append("circle").attr({
          cx: originX,
          cy: originY,
          r: innerCircleRadius,
          fill: v.selected ? "yellow" : "none",
          stroke: "black",
        });

        svg
          .append("text")
          .attr({
            x:
              originX -
              (Number(v.text) > 9 ? (Number(v.text) > 99 ? 12 : 9) : 3),
            y:
              originY +
              (Number(v.text) > 9 ? (Number(v.text) > 99 ? 5 : 5) : 5),
            "font-size": 15,
          })
          .text(v.text);

        for (let i = 0; i < 1200; i += v.val) {
          const chairOriginX1 =
            originX - 3 + (outerCircleRadius1 + 16) * Math.sin(i);
          const chairOriginY1 =
            originY + 2 - (outerCircleRadius1 + 16) * Math.cos(i);
          const chairOriginX = originX + (outerCircleRadius + 5) * Math.sin(i);
          const chairOriginY = originY - (outerCircleRadius + 5) * Math.cos(i);

          svg.append("circle").attr({
            cx: i == 1200 ? Math.ceil(chairOriginX + 1) : chairOriginX,
            cy: chairOriginY,
            r: 4,
            fill:
              vm.dict[v.text] &&
              vm.dict[v.text].includes(i > 0 ? Math.ceil(i / v.val) : 0)
                ? vm.dictlist[v.text] || "pink"
                : "lightgrey",
          });

          svg
            .append("text")
            .attr({
              x: chairOriginX1,
              y: chairOriginY1,
              stroke: "black",
              "font-size": 10,
            })
            .text(() => {
              return i > 0 ? Math.ceil(i / v.val) + 1 : 1;
            });
        }
      });

      /// rects
      svg
        .append("rect")
        .attr("width", 130)
        .attr("height", 120)
        .attr("x", 400)
        .attr("y", 125)
        .attr("fill", "none")
        .attr("stroke", "black");
      svg
        .append("text")
        .attr("x", 425)
        .attr("y", 195)
        .text("Dance Floor")
        .attr("fill", "none")
        .attr("stroke", "black");

      svg
        .append("rect")
        .attr("width", 130)
        .attr("height", 115)
        .attr("x", 400)
        .attr("y", 10)
        .attr("fill", "none")
        .attr("stroke", "black");
      svg
        .append("text")
        .attr("x", 445)
        .attr("y", 70)
        .text("Stage")
        .attr("fill", "none")
        .attr("stroke", "black");
    },
    individualTick(list) {
      return list.filter((listRecord) =>
        this.individualsData.includes(listRecord.ticketCode)
      );
    },
    groupTickets(list) {
      return list.filter((listRecord) =>
        this.groupData.includes(listRecord.ticketCode)
      );
    },
    openZelleModel: function () {
      this.$refs.zellemodal.open();
    },
    onChangeTicket: function (evt) {
      const countsList = [];

      (this.eventTicketResult || []).forEach((selectedTicket, idx) => {
        if (selectedTicket.ticketName === evt.target.value) {
          this.ticketForm.ticketId = selectedTicket.ticketCode;
          const at = this.eventTicketResult[idx].availableTickets;
          const apr = this.eventTicketResult[idx].allowedPerRequest;

          for (let k = 0; k < (at > apr ? apr : at); k++) {
            countsList.push(k + 1);
          }
        }
      });

      this.countsListShow = countsList;
    },
    validateFileType: function (ee) {
      const fileName = document.getElementById("fileName").value;
      const idxDot = fileName.lastIndexOf(".") + 1;
      const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
      if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
        this.ticketForm.file = ee.target.files[0];
      }
    },
    openmodel: function (mod) {
      let idx = 0;
      this.TicketsResult.forEach((i, i1) => {
        if (i.ticketCode == mod.ticketCode) {
          idx = i1;
        }
      });

      this.redeemData = null;
      this.selectionList = [];
      this.redeemPriceId = "";
      this.isDonationPay = false;
      this.isDonation = false;
      this.email = "";
      this.reserveFormAccept = false;
      this.$refs.modal.open();
      this.selected = idx;
      this.pnumber = "";
      this.maddress = "";
      this.cstate = "";
      this.ccity = "";
      this.czipcode = "";
      this.company = "";
      this.followup = false;

      const rr = this.individualTick(this.TicketsResult);
      rr.forEach((s) => {
        if (s.ticketCode == this.TicketsResult[this.selected].ticketCode) {
          this.isDonation = true;
        }
      });

      if (
        this.TicketsResult[idx].availableSeating &&
        this.TicketsResult[idx].availableSeating[0] &&
        this.TicketsResult[idx].ticketCode == "tk_yfT2rMpbdhrWJNg"
      ) {
        this.availSeating = this.TicketsResult[idx].availableSeating[0].alias;
      } else if (
        this.TicketsResult[idx].availableSeating &&
        this.TicketsResult[idx].availableSeating[0] &&
        this.TicketsResult[idx].ticketCode == "tk_bMMncT7WBaGEmz0"
      ) {
        this.availSeating = this.TicketsResult[idx].availableSeating[0].table;
      } else if (
        this.TicketsResult[idx].availableSeating &&
        this.TicketsResult[idx].availableSeating[0] &&
        this.TicketsResult[idx].ticketCode == "tk_ZNDRjDCAnOGEjAn"
      ) {
        //  this.availSeating = this.TicketsResult[idx].availableSeating[0].table;
        this.availSeating = this.uniq1(
          this.TicketsResult[idx].availableSeating
        )[0];
      } else {
        this.availSeating = "";
      }
      this.tickcountlist = [];
      for (
        let k = 0;
        k <
        (this.TicketsResult[idx].availableTickets >
        this.TicketsResult[idx].allowedPerRequest
          ? this.TicketsResult[idx].allowedPerRequest
          : this.TicketsResult[idx].availableTickets);
        k++
      ) {
        this.tickcountlist.push(k + 1);
      }
    },
    fetchStatus() {
      const req = "https://myle-19701.uc.r.appspot.com/api/event_total_sales";
      const self = this;
      self.thermoResult = 5;
      axios
        .post(req, {
          eventId: "vbMG0rRJBaD3Zu",
          userId: "",
        })
        .then((res) => {
          if (res && res.data && res.data.Result) {
            self.thermoResult =
              res.data.Result.totalSales > 0
                ? res.data.Result.totalSales / 1000
                : 5;
          }
        });
    },
    paynow: function () {
      /**
       * This function here is for  pay methods
       */
      this.isSubmitted = true;
      const vm = this;
      const payloadToPush = {
        priceId:
          this.TicketsResult[vm.selected].discount &&
          this.redeemPriceId.trim().length
            ? this.redeemPriceId
            : this.priceIds[this.TicketsResult[vm.selected].ticketCode],
        eventId: this.TicketsResult[vm.selected].eventId,
        ticketId: this.TicketsResult[vm.selected].ticketCode,
        totalTickets: this.tickcount,
        userName: this.fullname,
        userEmail: this.email.toLowerCase(),
      };

      if (vm.groupData.includes(vm.TicketsResult[vm.selected].ticketCode)) {
        payloadToPush.extraInfo["required_power_needs"] =
          vm.required_power_needs;
      }

      payloadToPush.extraInfo = payloadToPush.extraInfo || {};
      payloadToPush.extraInfo["phone_number"] = this.pnumber;
      payloadToPush.extraInfo["mailing_address"] = this.maddress;
      payloadToPush.extraInfo["state"] = this.cstate;
      payloadToPush.extraInfo["city"] = this.ccity;
      payloadToPush.extraInfo["zip_code"] = this.czipcode;
      payloadToPush.extraInfo["company"] = this.company;
      payloadToPush.extraInfo["follow_up"] = this.followup;

      if (this.isDonation) {
        payloadToPush.extraInfo = payloadToPush.extraInfo || {};
        payloadToPush.extraInfo["anonymous_donation"] = this.isDonationPay;
      }

      if (vm.availSeating.length > 0) {
        payloadToPush.additionalInfo = {
          type: "Seating",
          value: this.availSeating,
        };
      }

      if (vm.TicketsResult[vm.selected].ticketCode == "tk_yfT2rMpbdhrWJNg") {
        const selectedRecs = [];
        this.selectionList.forEach((r) => {
          selectedRecs.push(r.alias);
        });
        payloadToPush.totalTickets = selectedRecs.length;
        payloadToPush.additionalInfo = {
          type: "Seating",
          value: selectedRecs,
        };
      }

      if (vm.TicketsResult[vm.selected].ticketCode == "tk_ZNDRjDCAnOGEjAn") {
        const selectedRecList = [];
        if (this.availSeating.endsWith("1 to 5")) {
          const initalval = this.availSeating.split("Seat 1 to 5")[0];
          selectedRecList.push(initalval + "- Seat 1");
          selectedRecList.push(initalval + "- Seat 2");
          selectedRecList.push(initalval + "- Seat 3");
          selectedRecList.push(initalval + "- Seat 4");
          selectedRecList.push(initalval + "- Seat 5");
        } else if (this.availSeating.endsWith("6 to 10")) {
          const initalval = this.availSeating.split("Seat 6 to 10")[0];
          selectedRecList.push(initalval + "- Seat 6");
          selectedRecList.push(initalval + "- Seat 7");
          selectedRecList.push(initalval + "- Seat 8");
          selectedRecList.push(initalval + "- Seat 9");
          selectedRecList.push(initalval + "- Seat 10");
        }
        //  payloadToPush.totalTickets = selectedRecList.length;
        payloadToPush.additionalInfo = {
          type: "Seating",
          value: selectedRecList,
        };
      }

      const req =
        "https://myle-19701.uc.r.appspot.com/api/" +
        ((this.TicketsResult[vm.selected].ticketType != "FREE" &&
          !this.redeemData) ||
        (this.redeemData && this.redeemData.price !== 0)
          ? "requested_tickets"
          : "requested_free_tickets");
      axios
        .post(req, payloadToPush)
        .then((re) => {
          if (re.data && re.data.Result && re.data.Result.sessionId) {
            vm.checkout.clientReferenceId = re.data.Result.sessionId;
            localStorage.setItem("refsId", vm.checkout.clientReferenceId);
            vm.$refs.checkoutRef.redirectToCheckout();
          } else if (
            vm.TicketsResult[vm.selected].ticketType === "FREE" ||
            (vm.redeemData && vm.redeemData.price === 0)
          ) {
            vm.$toast.success(re.data.Message, { timeout: 4000 });
            vm.$refs.modal.close();
            vm.reserveFormAccept = false;

            vm.fullname = "";
            vm.email = "";
            vm.isSubmitted = false;
          }

          setTimeout(() => {
            vm.isSubmitted = false;
          }, 60000);
          vm.reserveFormAccept = false;
        })
        .catch(() => {
          vm.isSubmitted = false;
          vm.reserveFormAccept = false;
        });
    },
    fetchLastSales: function () {
      const vm = this;
      axios
        .post("https://myle-19701.uc.r.appspot.com/api/event_total_sales", {
          eventId: "vbMG0rRJBaD3Zu",
          userId: "",
        })
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.Result &&
            res.data.Result.lastOrders &&
            res.data.Result.lastOrders.length > 0
          ) {
            vm.salesRecords = res.data.Result.lastOrders;
          }
        });
    },
    fetchAllTickets: function () {
      /**
       * This function here is used to fetch tickets
       */

      const vm = this;
      this.isSubmitted = true;
      this.eventTicketResult = [];
      this.TicketsResult = [];
      axios
        .get(
          "https://myle-19701.uc.r.appspot.com/api/fetchSponsoredColumbusUrbanLeagueEmpowermentDay_eventtickets"
        )
        .then((ticketsResult) => {
          if (
            ticketsResult &&
            ticketsResult.data &&
            ticketsResult.data.Result
          ) {
            vm.TicketsResult = ticketsResult.data.Result;
          }

          const objtmp = {
            tk_CoHMzgGR158saAH: null,
            tk_Z8a9fe56BHx9bHr: null,
            tk_tlZEJ3dMf2U4WsJ: null,
            tk_uSBo0TmAenxf2CP: null,
            tk_M2iH8xEoWy9DGWO: null,
            tk_tAf85haTa6yuouR: null,
            tk_VVhdyaMxvqd4z0K: null,
            tk_rTolQ7vpgNhGYWt: null,
            tk_EtX0chUOgRB9FY5: null,
            tk_S3V709sEL88Mcx4: null,
            tk_d0GTCEWbGLuAua7: null,
          };

          vm.TicketsResult.forEach((tr) => {
            objtmp[tr.ticketCode] = tr; // tr.status="EXPIRED";
          });
          vm.TicketsResult = Object.values(objtmp);
          vm.eventTicketResult = vm.TicketsResult;
          vm.isSubmitted = false;
          vm.drawseatsd2(vm.eventTicketResult);

          const rr = this.individualTick(vm.TicketsResult);
          rr.forEach((s) => {
            if (s.ticketCode == vm.TicketsResult[vm.selected].ticketCode) {
              vm.isDonation = true;
            }
          });
        })
        .catch(() => {
          vm.isSubmitted = false;
        });
    },
    redeem: function () {
      const vm = this;
      vm.isSubmitted = true;
      axios({
        method: "post",
        url: "https://myle-19701.uc.r.appspot.com/api/redeem_promo_code",
        data: {
          eventId: this.TicketsResult[this.selected].eventId,
          ticketId: this.TicketsResult[this.selected].ticketCode,
          promoCode: this.redeempromo,
        },
      })
        .then((re) => {
          if (re.data.Status === "Success") {
            vm.$toast.success(re.data.Message, { timeout: 4000 });
            vm.redeemPriceId = re.data.Result.discountedPriceId;
            vm.redeemData = re.data.Result;
          }
          vm.isSubmitted = false;
        })
        .catch(() => {
          vm.isSubmitted = false;
          vm.$toast.error("Promo code failed", { timeout: 4000 });
          vm.redeemPriceId = "";
          vm.redeemData = null;
        });
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[arr.length - 1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    payfornow: function () {
      /**
       * This function here is for Reservation form
       */

      // holding reference
      const vm = this;
      vm.isSubmitted = true;

      // creating form Data
      const bodyFormData = new FormData();
      bodyFormData.append("fullName", this.ticketForm.name);
      bodyFormData.append("email", this.ticketForm.email.toLowerCase());
      bodyFormData.append("phoneNumber", this.ticketForm.phone);
      bodyFormData.append("ticketId", this.ticketForm.ticketId);
      bodyFormData.append("quantity", this.ticketForm.ticketCount);
      bodyFormData.append("paymentType", this.ticketForm.method);
      bodyFormData.append(
        "extraInfo",
        JSON.stringify({
          state: this.constate,
          city: this.concity,
          zip_code: this.conzipcode,
          company: this.concompany,
          follow_up: this.confollowup,
          mailing_address: this.conaddress,
          anonymous_donation: this.conisDonationPay,
        })
      );
      bodyFormData.append(
        "paymentReceipt",
        this.dataURLtoFile(
          "data:image/png;base64,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",
          "myle.png"
        )
      );

      // making api call
      axios({
        method: "post",
        url: "https://myle-19701.uc.r.appspot.com/api/ticket_order_confirmation",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((re) => {
          if (re.data.Status === "Success") {
            vm.$toast.success(re.data.Message, { timeout: 4000 });
          }
          // make get request again
          this.fetchAllTickets();
          vm.ticketForm = {
            name: "",
            email: "",
            phone: "",
            ticketCount: 1,
            ticketName: "",
            ticketId: "",
            method: "",
            accept: "",
            file: null,
          };
          this.concity = "";
          this.constate = "";
          this.conzipcode = "";
          this.concompany = "";
          this.conaddress = "";
          this.conisDonationPay = false;
          this.confollowup = false;
          document.getElementById("fileName").value = "";
          vm.isSubmitted = false;
        })
        .catch(() => {
          vm.isSubmitted = false;
          vm.ticketForm = {
            name: "",
            email: "",
            phone: "",
            ticketCount: 1,
            ticketName: "",
            ticketId: "",
            method: "",
            accept: "",
            file: null,
          };
          this.concity = "";
          this.constate = "";
          this.conzipcode = "";
          this.concompany = "";
          this.conaddress = "";
          this.conisDonationPay = false;
          this.confollowup = false;
          document.getElementById("fileName").value = "";
          vm.$toast.error("Ticket Confirmation failed", { timeout: 4000 });
        });
    },
  },
  created() {
    // if (this.$route.path == "/new-years-eve-2021-@-stadium") {
    //  this.$router.push("new-years-eve-2022-@-stadium");
    // }
  },
  destroyed() {
    clearInterval(this.intID);
  },
  mounted() {
    this.fetchStatus();
    this.fetchLastSales();
    this.intID = setInterval(() => {
      this.fetchLastSales();
    }, 120000);
    this.fetchAllTickets();
    const id = localStorage.getItem("refsId");
    if (
      id &&
      this.$route &&
      this.$route.query &&
      this.$route.query.checkout == "success"
    ) {
      this.$toast.success("Please check your provided email for tickets.", {
        timeout: 8000,
      });
      localStorage.removeItem("refsId");
    } else if (
      id &&
      this.$route &&
      this.$route.query &&
      this.$route.query.checkout == "failed"
    ) {
      this.$toast.error("Ticket reservation canceled", { timeout: 6000 });
      localStorage.removeItem("refsId");
    }
  },
  computed: {
    invalidTicketEmail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        this.ticketForm.email
      );
    },
    invalidPhoneNum() {
      return (
        (this.pnumber || "").match(/\d/g) &&
        (this.pnumber || "").trim().length >= 10
      );
    },
    invalidTicketPhone() {
      return (
        (this.ticketForm.phone || "").match(/\d/g) &&
        (this.ticketForm.phone || "").trim().length >= 10
      );
    },
    invalidemail() {
      return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.email);
    },
    invalidphone() {
      return (
        (this.phone || "").match(/\d/g) &&
        (this.phone || "").trim().length >= 10
      );
    },
  },

  metaInfo: {
    title: "MYLE - Columbus Urban League Empowerment Day",

    meta: [
      {
        name: "description",
        content: "MYLE - Columbus Urban League Empowerment Day",
      },

      {
        name: "keywords",
        content: "MYLE - Columbus Urban League Empowerment Day",
      },

      {
        name: "copyright",
        content: "MYLE",
      },

      {
        name: "url",
        content: "https://myle.com/columbus-urban-league-empowerment-day",
      },
    ],
  },
};
</script>

<style scoped>
#reserve {
  color: white;
}
#reserve:hover {
  color: #104233;
}
.background-overlay {
  background: #114436c4 !important;
  max-width: 100%;
  z-index: 9999 !important;
}
#banner {
  background-size: cover;
}
.innerimg {
  margin: auto;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 1;
  max-width: 80%;
  height: auto;
  border: 1px double #d7c57d;
}

.bg-disable {
  background: pink;
  border: 1px solid pink;
  color: red !important;
  pointer-events: none;
}

@media (max-width: 768px) {
  #redeem {
    text-align: center;
  }
}

@media (max-width: 922px) {
  #d2 {
    overflow-x: scroll;
  }
}
@media (min-width: 922.1px) {
  #d2 {
    overflow-x: hidden;
  }
}

.cred {
  background: #c07f00 !important;
  border: 1px solid #c07f00 !important;
}

.cgreen {
  background: #0ea293;
  border: 1px solid #0ea293 !important;
}

.cgold {
  background: #a19140;
  border: 1px solid #a19140 !important;
}

/* The animation code */
@keyframes example {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* The element to apply the animation to */
.texts {
  animation-name: example;
  animation-duration: 2s;
  display: block;
  padding: 10px;
  font-size: 16px;
  text-align: center;
  color: rgb(20, 81, 67);
  animation-fill-mode: backwards;
}

.fullwidth {
  width: 100%;
}

.amount {
  font-weight: bold;
  margin-right: 50px;
}

.fullName {
  font-weight: bold;
  margin-right: 50px;
  font-family: "Quicksand", sans-serif;
  font-weight: 500;
  font-size: 24px;
}
</style>
